import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=a87d5228&scoped=true&"
import script from "./ImageSelector.vue?vue&type=script&lang=js&"
export * from "./ImageSelector.vue?vue&type=script&lang=js&"
import style0 from "./ImageSelector.vue?vue&type=style&index=0&id=a87d5228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87d5228",
  null
  
)

export default component.exports